import { defineMessages } from 'react-intl';

const messages = defineMessages({
  isPhoneNumberPublic: {
    id: 'components.phoneNumber.isPhoneNumberPublic',
    defaultMessage: 'Make this Phone Number Public',
  },
  isPhoneNumberPublicHelperText: {
    id: 'components.phoneNumber.isPhoneNumberPublicHelperText',
    defaultMessage:
      'If checked, this phone number will be visible to others who are visiting your profile.',
  },
  phoneNumberLabel: {
    id: 'components.phoneNumber.phoneNumberLabel',
    defaultMessage: 'Phone number',
  },
});

export default messages;
